import React, {
  useContext,
  useEffect,
  useRef,
  useState,
  useTransition,
} from "react";
import "./CadastraEmpresaRPA.scss";
import { useForm } from "react-hook-form";
import GlobalContext from "@context/GlobalContext";
import Input from "@components/input/Input";
import UtilServices from "@services/UtilServices";
import Button from "@components/button/Button";
import DropDownList from "@components/dropDownList/DropDownList";
import EndPointServices from "@services/ApiServices";
import MessageServices from "@services/MessageServices";
import Grid from "@components/grid/Grid";
import ButtonIcon from "@components/buttonIcon/ButtonIcon";
import mappingColumn from "@components/grid/mappingColumn";
import Modal from "@components/modal/Modal";
import useLoading from "@hooks/useLoading";
import CheckBox from "@components/checkbox/CheckBox";
import IconSistemaDominio from "@icons/IconSistemaDominio";

const CadastraEmpresaRPA = () => {
  const [isPending, startTransition] = useTransition();
  const [isPendingB, startTransitionB] = useTransition();
  useLoading(isPending);

  // Segundo formulário
  const {
    register: registerFormB,
    handleSubmit: handleSubmitFormB,
    formState: { errors: errorsFormB },
    setValue: setValueFormB,
    reset: resetFormB,
    watch: watchFormB,
  } = useForm();

  //Variaveis Padrões
  const [state] = useContext(GlobalContext);

  //input arquivo .txt.
  const fileInputRef = useRef(null);
  const fileInputRefMultiple = useRef(null);

  //input arquivo massivo .txt.
  const [dadosMassivo, setDadosMassivo] = useState([]);

  //Certificado
  const [lstCertificado, setLstCertificado] = useState([]);

  //Modal
  const [showModal, setShowModal] = useState(false);
  const [retornoErros, setRetornoErros] = useState([]);

  //Check
  const [check, setCheck] = useState(false);

  //
  const sectionRef = useRef(null);

  useEffect(() => {
    handleLstCertificado();
  }, []);

  async function handleSalvarMassivamente(e) {
    if (
      !dadosMassivo?.resultadoMassivo?.filter(
        (item) => item.status === "Sucesso",
      ).length
    ) {
      MessageServices.ShowWarning("Os arquivos importados são inválidos!");
      return;
    }

    startTransition(async () => {
      let seenCNPJs = new Set();

      let filtrados =
        dadosMassivo?.resultadoMassivo
          ?.filter((item) => item.status === "Sucesso")
          .filter((item) => {
            // remove duplicidade
            if (seenCNPJs.has(item.cnpj)) {
              return false;
            } else {
              seenCNPJs.add(item.cnpj);
              return true;
            }
          }) || [];

      let dados = {
        dadosmassivo: [
          ...filtrados.map((item) => ({
            ...item,
            id_dominio: e[`iddominio_${item?.cnpj}`] || null,
            spedgeradodominio: e?.spedgeradodominio,
            competencia: e["competencia"]
              ? e["competencia"]
              : item?.competencia,
          })),
        ],
        id_certificado: valueDropDownLst_B?.certificadoa1?.id,
        filarobo: e?.filarobo,
        flg_ignoraraviso: check,
      };

      let data = {
        id_usuario_guid: state.dadosusuario?.id_usuario_guid,
        id_usuario: state.dadosusuario?.id_usuario,
        json: dados,
      };

      var retornoapi = await EndPointServices.Rpa_AdicionarEmpresaArquivo(data);
      if (retornoapi?.Success) {
        if (retornoapi?.BaseReturn?.LstClasse?.length > 0) {
          MessageServices.ShowWarning(
            "Cadastro realizado com alguns alertas. !",
          );
          const grupos = retornoapi.BaseReturn.LstClasse.reduce((acc, item) => {
            if (!acc[item.msg]) acc[item.msg] = [];
            acc[item.msg].push(item);
            return acc;
          }, {});
          setRetornoErros(grupos);
          setShowModal(true);
        } else {
          MessageServices.ShowSuccess("Cadastro realizado com sucesso !");
        }
        resetFormB();
        setValueDropDownLst_B([]);
        setDadosMassivo([]);
        handleLstCertificado();
      }
    });
  }
  function handleLstCertificado() {
    startTransition(async () => {
      let data = {
        id_usuario_guid: state.dadosusuario?.id_usuario_guid,
        id_usuario: state.dadosusuario?.id_usuario,
      };

      var retornoapi = await EndPointServices.Cliente_ConsultaCertificado(data);
      if (retornoapi?.Success) {
        if (retornoapi?.BaseReturn?.LstClasse?.length > 0) {
          setLstCertificado(
            retornoapi?.BaseReturn?.LstClasse.map((item, index) => ({
              id: item?.id_certificado,
              key: item?.certificado,
            })),
          );
          //Deixar o primeiro como Default. (Massivo)
          handleChangeDropDownLst_B(
            "certificadoa1",
            retornoapi?.BaseReturn?.LstClasse?.[0].certificado,
            {
              id: retornoapi?.BaseReturn?.LstClasse?.[0]?.id_certificado,
              key: retornoapi?.BaseReturn?.LstClasse?.[0]?.certificado,
            },
          );
        }
      }
    });
  }
  async function handleUploadTxt(event, flgmassivamente = false) {
    let file;
    let resultado = [];
    let resultadoMassivo = [];

    if (flgmassivamente) {
      file = event;
      if (!file) {
        resultadoMassivo.push({
          status: "Erro",
          filename: "",
          observacao: "Arquivo não existe.",
          cnpj: "",
          razaosocial: "",
          inscricaoEstadual: "",
          regime: "",
          competencia: "",
          base64: "",
        });

        //state
        setDadosMassivo((prev) => ({
          ...prev,
          resultadoMassivo: [
            ...(Array.isArray(prev?.resultadoMassivo)
              ? prev.resultadoMassivo
              : []),
            ...(Array.isArray(resultadoMassivo) ? resultadoMassivo : []),
          ],
        }));

        return;
      }
    }

    const text = await file.text();
    const linhas = text.split("\n");

    for (const linha of linhas) {
      const campos = linha.trim().split("|");

      // Registro 0000: tipo de apuração
      if (campos[1] === "0000") {
        const mes = campos[6]?.substring(2, 4);
        const ano = campos[6]?.substring(4, 8);
        resultado.competencia = `${mes}/${ano}`;
      }

      // Registro 0110: tipo de apuração
      if (campos[1] === "0110") {
        const empresa = {};

        if (campos[2] === "1") {
          empresa.regime = { id: 1, key: "não-cumulativo (Lucro Real)" };
        }
        if (campos[2] === "2") {
          empresa.regime = { id: 0, key: "cumulativo (Lucro Presumido)" };
        }
        if (campos[2] === "3") {
          empresa.regime = {
            id: 2,
            key: "não-cumulativo e cumulativo (Lucro Real)",
          };
        }
        resultado.push(empresa);
      }

      // Registro 0140: dados da empresa
      if (campos[1] === "0140") {
        resultado.razaosocial = campos[3];
        resultado.cnpj = campos[4];
        resultado.inscricaoEstadual = campos[6];
        break;
      }
    }

    //Massivamente.
    if (flgmassivamente) {
      if (resultado.length === 0) {
        resultadoMassivo.push({
          status: "Erro",
          filename: file?.name,
          observacao: "Arquivo inválido",
          cnpj: "",
          razaosocial: "",
          inscricaoEstadual: "",
          regime: "",
          competencia: "",
          base64: "",
        });
        //state
        setDadosMassivo((prev) => ({
          ...prev,
          resultadoMassivo: [
            ...(Array.isArray(prev?.resultadoMassivo)
              ? prev.resultadoMassivo
              : []),
            ...(Array.isArray(resultadoMassivo) ? resultadoMassivo : []),
          ],
        }));
        return;
      }

      resultadoMassivo.push({
        status: "Sucesso",
        observacao: "Arquivo validado com sucesso.",
        filename: file?.name,
        cnpj: resultado?.cnpj,
        razaosocial: resultado?.razaosocial,
        inscricaoEstadual: resultado?.inscricaoEstadual,
        regime: resultado?.[0]?.regime.key,
        competencia: resultado?.competencia,
        base64: await UtilServices.readFileAsBase64B(file),
      });
      //state
      setDadosMassivo((prev) => ({
        ...prev,
        resultadoMassivo: [
          ...(Array.isArray(prev?.resultadoMassivo)
            ? prev.resultadoMassivo
            : []),
          ...(Array.isArray(resultadoMassivo) ? resultadoMassivo : []),
        ],
      }));
    }
  }
  async function handleUploadExcel(event) {
    let resultadoMassivo = [];

    let retornojson = await UtilServices.handleUploadExcel(event, [
      "*cnpj",
      "*razao_social",
      "*regime",
      "iddodominio",
    ]);

    if (Array.isArray(retornojson)) {
      for (let resultado of retornojson) {
        let status = "Sucesso";

        //Valida campos.
        if (!UtilServices.validateCNPJ(String(resultado?.["*cnpj"]))) {
          status = "Erro Cnpj Inválido";
        }
        if (resultado?.iddodominio != null && resultado.iddodominio !== "") {
          if (!/^\d+$/.test(resultado.iddodominio)) {
            status += " | Id do domínio só pode conter números";
          }
        }
        resultadoMassivo.push({
          status: status,
          observacao: "Arquivo validado com sucesso.",
          filename: resultado.filename,
          cnpj: String(resultado?.["*cnpj"]).replace(/[^\d]+/g, ""),
          razaosocial: resultado?.["*razao_social"],
          inscricaoEstadual: null,
          regime: resultado?.["*regime"],
        });

        if (
          resultado?.iddodominio != null &&
          resultado.iddodominio !== "" &&
          status === "Sucesso"
        ) {
          handleChangeDropDownLst_B(
            "spedgeradodominio",
            "Sim",
            {
              id: 1,
              key: "Sim",
            },
            true,
          );
          handleChangeDropDownLst_B(
            `iddominio_${String(resultado?.cnpj).replace(/[^\d]+/g, "")}`,
            resultado?.iddodominio,
          );
        }
      }

      //state
      setDadosMassivo((prev) => ({
        ...prev,
        resultadoMassivo: [
          ...(Array.isArray(prev?.resultadoMassivo)
            ? prev.resultadoMassivo
            : []),
          ...(Array.isArray(resultadoMassivo) ? resultadoMassivo : []),
        ],
      }));
    }
  }
  async function handleSelecionarArquivos(event) {
    startTransition(async () => {
      const arquivos = Array.from(event.target.files);

      for (const arquivo of arquivos) {
        const extensao = arquivo.name.split(".").pop().toLowerCase();

        if (extensao === "txt") {
          await handleUploadTxt(arquivo, true);
        } else if (extensao === "xlsx") {
          await handleUploadExcel(arquivo);
        }
      }

      handleScroll();
      fileInputRefMultiple.current.value = "";
    });
  }
  const [valueDropDownLst_B, setValueDropDownLst_B] = useState([]);
  function handleChangeDropDownLst_B(
    name,
    value,
    valueAdicionar,
    flg_excel = false,
  ) {
    if (
      ["filarobo", "spedgeradodominio"].includes(name) &&
      dadosMassivo.length === 0 &&
      flg_excel === false
    ) {
      MessageServices.ShowWarning("É necessário fazer upload dos arquivos.");
      return;
    }
    setValueFormB(name, value);
    setValueDropDownLst_B((prevState) => ({
      ...prevState,
      [name]: valueAdicionar,
    }));
  }

  //scroll
  function handleScroll() {
    sectionRef.current?.scrollIntoView({
      behavior: "smooth",
      block: "end",
    });

    if (sectionRef.current) {
      sectionRef.current.classList.add("highlight");
      // remove a classe depois da animação
      setTimeout(() => {
        sectionRef.current.classList.remove("highlight");
      }, 2000); // mesmo tempo do animation
    }
  }

  return (
    <div className="cadastrarempresarpa">
      {/* Importação Massivo */}
      <form
        onSubmit={handleSubmitFormB(handleSalvarMassivamente)}
        className="row mb-4"
      >
        <div className="upload-massivo d-flex flex-md-row flex-column justify-content-md-between align-items-center">
          <div style={{ display: "flex", alignItems: "center", gap: "10px" }}>
            <Button
              nome="Upload Massivo"
              className="passo-1"
              title="Faça o upload massivo."
              icon="<i class='fa-solid fa-upload'></i>"
              theme="2"
              type="button"
              onClick={() => {
                fileInputRefMultiple.current.click();
              }}
            />
            <Button
              nome="Download Template"
              className="passo-2"
              title="Faça o download do template Excel."
              icon="<i class='fa-solid fa-download'></i>"
              theme="3"
              type="button"
              onClick={() => {
                UtilServices.handleExport(
                  ["*cnpj", "*razao_social", "*regime", "iddodominio"],
                  "template_importacaomassiva",
                  null,
                );
              }}
            />
            <ButtonIcon
              Clear
              onClear={() => {
                setDadosMassivo([]);
                setValueDropDownLst_B([]);
                resetFormB();
                handleLstCertificado();
              }}
              typeClear="button"
              titleClear="Limpar todos os arquivos."
            />
          </div>
          <div>
            <Button
              nome="Cadastro Massivo"
              icon="<i class='fa-solid fa-plus'></i>"
              theme="2"
            />
          </div>
        </div>
        {/* <div className="col-md-3 col-12 mt-2">
          <DropDownList
            title="Qual Automação ?"
            setValue={setValueFormB}
            register={registerFormB}
            errors={errorsFormB}
            name="qualautomacao"
            value={valueDropDownLst_B["qualautomacao"]}
            onChange={handleChangeDropDownLst_B}
            data={[
              { id: 1, key: "EFD Contribuição" },
              { id: 2, key: "Receita BX" },
            ]}
            // disabled
          />
        </div> */}
        <div className="col-md-12 col-12 mt-2 mb-5 passo-3">
          <DropDownList
            title="Certificado A1"
            setValue={setValueFormB}
            register={registerFormB}
            errors={errorsFormB}
            // required
            loading={isPending}
            name="certificadoa1"
            value={valueDropDownLst_B["certificadoa1"]}
            onChange={handleChangeDropDownLst_B}
            data={lstCertificado}
            // registerProps={{
            //   required: "Certificado obrigatório",
            // }}
          />
          <CheckBox
            checked={check}
            className="col-md-9 col-12 mt-3"
            onChange={(e) => setCheck(e.target.checked)}
            title="Ignorar possíveis avisos nos arquivos sped ?"
          />
        </div>
        {/* Sistema Dominio */}
        <div className="col-12 icon-default">
          <IconSistemaDominio />
          <p>Sistema Dominio</p>
        </div>
        <div className="col-md-3 col-12 mt-2 passo-4">
          <DropDownList
            title="*Sped gerado pelo Dominio ?"
            placeholder="Selecione Sim ou Não"
            setValue={setValueFormB}
            register={registerFormB}
            errors={errorsFormB}
            required
            name="spedgeradodominio"
            value={valueDropDownLst_B["spedgeradodominio"]}
            onChange={handleChangeDropDownLst_B}
            data={[
              { id: 1, key: "Sim" },
              { id: 0, key: "Não" },
            ]}
            registerProps={{
              required: "Campo obrigatório",
            }}
            tooltip
            tooltipDescricao="Informe se o SPED será gerado automaticamente no sistema Domínio (Sim ou Não)."
            tooltipId="tooltip-001"
            tooltipIconColor="#FFDF5E"
            tooltipIcon={<i class="fa-regular fa-question"></i>}
          />
        </div>
        <div className="col-12 mb-5 row">
          {valueDropDownLst_B["spedgeradodominio"]?.key === "Sim" &&
            dadosMassivo?.resultadoMassivo
              ?.filter((item) => item.status === "Sucesso")
              .map((item, index) => (
                <>
                  <div className="col-6 mt-2">
                    <Input
                      dflex={false}
                      title="Empresa"
                      value={item?.razaosocial}
                      maxLength="5"
                      type="document"
                      disabled
                    />
                  </div>
                  <div className="col-6 mt-2 id-empresa-dominio">
                    <Input
                      dflex={false}
                      title="ID no Dominio ?"
                      setValue={setValueFormB}
                      register={registerFormB}
                      errors={errorsFormB}
                      name={`iddominio_${item?.cnpj}`}
                      maxLength="5"
                      type="number"
                      registerProps={{
                        required:
                          valueDropDownLst_B["spedgeradodominio"]?.key !== "Sim"
                            ? false
                            : "ID do Dominio obrigatório",
                      }}
                    />
                  </div>
                </>
              ))}
        </div>
        {/* {valueDropDownLst_B["qualautomacao"].id === 2 && (
          <div className="col-md-4 col-12 passo-4">
            <DropDownList
              title="*Período de Consulta"
              placeholder="Selecione o período desejado"
              setValue={setValueFormB}
              register={registerFormB}
              errors={errorsFormB}
              required
              name="periododeconsultabx"
              value={valueDropDownLst_B["periododeconsultabx"]}
              onChange={handleChangeDropDownLst_B}
              data={[
                { id: 0, key: "Ano Atual" },
                { id: 1, key: "Últimos 2 anos" },
                { id: 2, key: "Últimos 3 anos" },
                { id: 3, key: "Últimos 4 anos" },
                { id: 4, key: "Últimos 5 anos" },
              ]}
              registerProps={{
                required: "Campo obrigatório",
              }}
              tooltip
              tooltipDescricao="Selecione o período para o qual deseja consultar os dados de receita."
              tooltipId="tooltip-001"
              tooltipIconColor="#FFDF5E"
              tooltipIcon={<i class="fa-regular fa-question"></i>}
            />
          </div>
        )} */}
      </form>
      <div
        ref={sectionRef}
        style={{ padding: "5px", borderRadius: "15px", marginBottom: "20px" }}
      >
        <Grid
          className="passo-6"
          dadosGrid={dadosMassivo?.resultadoMassivo}
          columns={mappingColumn.getCadastroRPA_ImportacaoMassiva(
            dadosMassivo?.resultadoMassivo,
          )}
          {...(dadosMassivo?.resultadoMassivo?.length > 0 && {
            pageVisible: true,
          })}
          exportExcel={false}
          columnSelector={false}
          searchPanel={false}
          Memo={false}
          useLoading={isPendingB}
          pagingStaticSize="10"
        />
      </div>
      <input
        type="file"
        ref={fileInputRefMultiple}
        multiple
        onChange={handleSelecionarArquivos}
        style={{ display: "none" }}
        accept=".txt, .xlsx"
      />

      <Modal
        showModal={showModal}
        setShowModal={setShowModal}
        title="Alertas"
        width="auto"
        height="500px"
      >
        <div className="retorno-erros">
          {Object.entries(retornoErros).map(([msg, items], index) => (
            <div
              key={index}
              style={{ marginBottom: "2rem" }}
              className="grupo-erros"
            >
              <div dangerouslySetInnerHTML={{ __html: msg }} />
              {items.map((item, i) => (
                <div
                  key={i}
                  style={{ marginLeft: "1rem", marginTop: "0.5rem" }}
                >
                  <p>
                    <strong>{item.razaosocial}</strong>
                  </p>
                  <p>{UtilServices.maskCNPJ(item.cnpj)}</p>
                </div>
              ))}
              <hr
                style={{
                  borderTop: "1px solid #ccc",
                  margin: "10px auto",
                  width: "350px",
                }}
              />
            </div>
          ))}
        </div>
      </Modal>
    </div>
  );
};

export default CadastraEmpresaRPA;
